<a mat-list-item class="news-item" [routerLink]="['news', item?.id]" [state]="item">
    <mat-icon mat-list-icon>info</mat-icon>
    <h4 mat-line>{{ item?.title }}</h4>
    <!-- ska trunceras. Ellipsis? -->
    <p mat-line>{{ item?.body }}</p>
    <mat-divider></mat-divider>
</a>
